import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "You have access!", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "If you can see this page, you have access!")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_MainSection = _resolveComponent("MainSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, null, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_MainSection, null, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ], 64))
}